export default __webpack_public_path__ + "static/media/Note_4_img.c9153c20.jpg";